import { useQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { employeeKeys } from '@petseo/shared';

interface UseEmployeesOptions {
  includeInactive?: boolean;
}

export const useEmployees = (serviceVendorId: ServiceVendorId, { includeInactive = false }: UseEmployeesOptions = {}) => {
  return useQuery({
    queryKey: employeeKeys.forVendor(serviceVendorId),
    queryFn: async () => {
      const response = await serviceVendorsClient.getEmployeesEndpoint(serviceVendorId);
      return response.data;
    },
    select: (data) => {
      const employees = data.employees ?? [];
      return includeInactive ? employees : employees.filter((e) => e.isActive !== false);
    },
    enabled: !!serviceVendorId,
  });
};
